import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/listeaza-masina/")({
  head: () => routeHead("/listeaza-masina/"),
  beforeLoad: () => {
    throw redirect({ href: "/listeaza", statusCode: 301, replace: true });
  },
});
